import { render, staticRenderFns } from "./proxysmall.vue?vue&type=template&id=58e3b0be&scoped=true&"
import script from "./proxysmall.vue?vue&type=script&lang=js&"
export * from "./proxysmall.vue?vue&type=script&lang=js&"
import style0 from "./proxysmall.vue?vue&type=style&index=0&id=58e3b0be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e3b0be",
  null
  
)

export default component.exports